import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import {UserService} from '../../services/user';
import { Quill } from '../../components';
import './element-head-1.css';

export default class ElementHead1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "avatar_size": "width",
      "video_resize": "width",
      error_image: false,
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCategory = this.handleChangeCategory.bind(this);
    this.handleChangeAuthorName = this.handleChangeAuthorName.bind(this);
    this.handleChangeAuthorOffice = this.handleChangeAuthorOffice.bind(this);
    this.headerContainerRef = React.createRef();
    this.headerVideoRef = React.createRef();
    this.resizeVideo = this.resizeVideo.bind(this);
  }

  componentDidMount() {
    this.resizeVideo();
    this.onResize();
  }

  onResize() {
    var _this = this;
    window.addEventListener("resize", _this.resizeVideo);
  }

  resizeVideo() {
    if (this.props.content.background_video) {
      var container = this.headerContainerRef.current;
      var video = this.headerVideoRef.current;
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;
      var videoWidth = video.clientWidth;
      var videoHeight = video.clientHeight;

      var divideWidth = containerWidth / videoWidth;
      var divideHeight = containerHeight / videoHeight;

      this.setState({
        "video_resize": divideWidth > divideHeight ? "width": "height"
      });
    };
  }

  handleChange(content) {
    this.props.onChange(content);
  }

  handleAvatarChange(img) {
    this.setState({
      "avatar_size": img.target.width >= img.target.height ? "height" : "width"
    });
  }

  handleChangeCategory(category) {
    var content = this.props.content;
    content.category = category;
    this.props.onChange(content);
  }

  renderCategory() {
    let { content } = this.props;

    if (content.show_category === false) return null;

    var style = {
      borderColor: content.primary_color
    };

    return <Quill
      className="rdp-element-head-1-category"
      style={style}
      value={content.category}
      onChange={this.handleChangeCategory}
    />;
  }

  renderAvatar() {
    let { content } = this.props;

    if (content.avatar !== null) {
      var avatarSize = this.state.avatar_size;
      return <div className="rdp-element-head-1-avatar" style={{borderColor: content.avatar_border_color}}>
        <img
          style={avatarSize === "width" ? { width: "102%" } : { height: "102%" }}
          src={this.getAvatarUrl(content.avatar)}
          onLoad={this.handleAvatarChange.bind(this)}
        />
      </div>;
    } else {
      return null;
    }
  }

  getAvatarUrl(image) {
    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  handleChangeAuthorName(name) {
    var content = this.props.content;
    content.author_name = name;
    this.props.onChange(content);
  }

  handleChangeAuthorOffice(office) {
    var content = this.props.content;
    content.author_office = office;
    this.props.onChange(content);
  }

  renderAuthorInfo() {
    let { content } = this.props;

    if (content.show_author_name === false) return null;

    var modules = {
      toolbar: [
        ['bold', 'italic', 'underline','strike'], [{'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color']}]
      ],
    };
    var formats = ['bold', 'italic', 'underline', 'strike', 'color'];
    
    return <div className="rdp-element-head-1-author-info">
      <Quill
        className="rdp-element-head-1-author-name"
        value={content.author_name}
        onChange={this.handleChangeAuthorName}
      />
      <span className="rdp-element-head-1-author-divider" style={{color: content.primary_color}}> | </span>
      <Quill
        className="rdp-element-head-1-author-office"
        value={content.author_office}
        onChange={this.handleChangeAuthorOffice}
      />
    </div>
  }

  renderDivider() {
    let { content } = this.props;

    if (content.show_divider === false) return null;

    var secondaryColor = this.props.content.secondary_color;
    return <div className="rdp-element-head-1-divider" style={{background: secondaryColor}}></div>
  }

  getBackgroundUrl(image) {
    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  renderVideoBackground() {
    var accessToken = UserService.getUser().access_token;
    if (this.props.content.background_video) {
      return <video ref={this.headerVideoRef} className={`rdp-element-head-1-video-mask ${this.state.video_resize}`} autoplay="true" loop muted src={`${this.props.content.background_video}&access_token=${accessToken}`}/>
    }
  }

  getFont(font) {
    if (font) return font.replace(/\s/g, '-').toLowerCase();
  }

  getBackgroundStyle() {
    var style = {};
    if (this.props.content.background_image) {
      style = {
        backgroundImage: `url(${this.getBackgroundUrl(this.props.content.background_image)})`
      };
    }

    return style;
  }

  render() {
    let { headerActionsTemplate, footerActionsTemplate, content } = this.props;
    
    return <div ref={this.headerContainerRef} className={`rdp-element-head-1 ${this.getFont(content.font_family) || ""}`} style={this.getBackgroundStyle()}>
      {headerActionsTemplate}
      {this.renderVideoBackground()}
      {this.props.content.background_image !== null &&
        <img 
          alt="" 
          src={this.getBackgroundUrl(content.background_image)} 
          onError={e => {
            this.setState({ error_image: true })
            e.target.style.display = 'block';
            e.target.classList.add('broken-img');
          }}
          onLoad={e => {
            e.target.style.display = 'none';
            e.target.classList.remove('broken-img');
            this.setState({ error_image: false })
          }}
        />
      }
      {((!this.state.error_image && this.props.content.background_image !== null) || this.props.content.background_video !== null) && (
        <>
          {this.renderCategory()}
          {this.renderAvatar()}
          {this.renderAuthorInfo()}
          {this.renderDivider()}
        </>
      )}
      {footerActionsTemplate}
    </div>;
  }
}
